import type { AuditLogDetailsQueryParams, AuditLogQueryParams } from "@/components/AuditLog/AuditLogInterface";
import { privateRequest, type ApiResponse } from "../axios";

const ENDPOINTS = {
    COMPANY_SETTING_CURRENCY: "api/Currency",
    COMPANY_SETTING_TIMZONE: "api/Timezones",
    COMPANY_APP_SETTING: "api/Company/AppSetting",
    COMPANY_LOGO: "api/Company/AppSetting/Logo",
    COMPANY_SETTING_UPDATE: "api/SetDefaultCompanyAppSetting",
    COMPANY_DELETE: "api/Companies",
    GET_USER_SETTING: "api/Company/PermissionMailRecipients",
    COMPANY_SETTING_AUDIT_LOGS: "api/Company/UserSettingAuditLogs",
    GET_USER_SETTING_RECIPIENT: "api/Company/UserSettingsMailRecipients",
    GET_USER_SETTING_AUDIT_LOGS: "api/UserAuditLogs/UserSettings",
};

const getCurrencies = async (): Promise<ApiResponse<any>> => {
    const response = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.COMPANY_SETTING_CURRENCY);
    return response.data;
};

const getTimeZones = async (): Promise<ApiResponse<any>> => {
    const response = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.COMPANY_SETTING_TIMZONE);
    return response.data;
};

const getAppSetting = async (): Promise<ApiResponse<any>> => {
    const response = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.COMPANY_APP_SETTING);
    return response.data;
};

const updateCompanyLogo = async (payload: any): Promise<ApiResponse<any>> => {
    const response = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.COMPANY_LOGO, payload);
    return response.data;
};

const updateCompanySetting = async (payload: any): Promise<ApiResponse<any>> => {
    const response = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.COMPANY_SETTING_UPDATE, payload);
    return response.data;
};

const deleteCompany = async (): Promise<ApiResponse<any>> => {
    const response = await privateRequest.delete<ApiResponse<any>>(ENDPOINTS.COMPANY_DELETE);
    return response.data;
};

const getPermissionMailRecipients = async (): Promise<ApiResponse<any>> => {
    const response = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.GET_USER_SETTING);
    return response.data;
};

const getUserSettingsMailRecipient = async (): Promise<ApiResponse<any>> => {
    const response = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.GET_USER_SETTING_RECIPIENT);
    return response.data;
};

const getCompanySettingAuditLogs = async (params?: any): Promise<ApiResponse<any>> => {
    const response = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.COMPANY_SETTING_AUDIT_LOGS, { params });
    return response.data;
};

const getUserSettingAuditSummary = async (params?: AuditLogQueryParams): Promise<ApiResponse<any>> => {
    const response = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.GET_USER_SETTING_AUDIT_LOGS, { params });
    return response.data;
};

const getUserSettingAuditLogs = async (params?: AuditLogDetailsQueryParams): Promise<ApiResponse<any>> => {
    const response = await privateRequest.get<ApiResponse<any>>(`${ENDPOINTS.GET_USER_SETTING_AUDIT_LOGS}/${params?.userId}/Details`, { params });
    return response.data;
};

const CompanySettingService = {
    getCurrencies,
    getTimeZones,
    getAppSetting,
    updateCompanyLogo,
    updateCompanySetting,
    deleteCompany,
    getPermissionMailRecipients,
    getCompanySettingAuditLogs,
    getUserSettingAuditSummary,
    getUserSettingAuditLogs,
    getUserSettingsMailRecipient,
};

export default CompanySettingService;